var _dec, _class, _temp;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { FalsyFC, TouchableWeb } from "../../devsupport";
import { Interaction, styled } from "../../theme";
export
/**
 * A single action within the TopNavigation.
 * Actions should be rendered within TopNavigation by providing them through `accessory` props
 * to provide a usable component.
 *
 * @extends React.Component
 *
 * @property {(ImageProps) => ReactElement} icon - Function component
 * to render within the action.
 * Expected to return an Image.
 *
 * @property {string} appearance - Appearance of the component.
 * Can be `default` and `control`.
 * Use *control* appearance when needed to display within a contrast container.
 *
 * @property {TouchableOpacityProps} ...TouchableOpacityProps - Any props applied to TouchableOpacity component.
 *
 * @overview-example TopNavigationActionSimpleUsage
 */
let TopNavigationAction = (_dec = styled('TopNavigationAction'), _dec(_class = (_temp = class TopNavigationAction extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onBlur", event => {
      this.props.eva.dispatch([]);
      this.props.onBlur && this.props.onBlur(event);
    });

    _defineProperty(this, "onMouseEnter", event => {
      this.props.eva.dispatch([Interaction.HOVER]);
      this.props.onMouseEnter && this.props.onMouseEnter(event);
    });

    _defineProperty(this, "onMouseLeave", event => {
      this.props.eva.dispatch([]);
      this.props.onMouseLeave && this.props.onMouseLeave(event);
    });

    _defineProperty(this, "onFocus", event => {
      this.props.eva.dispatch([Interaction.FOCUSED]);
      this.props.onFocus && this.props.onFocus(event);
    });

    _defineProperty(this, "onPressIn", event => {
      this.props.eva.dispatch([Interaction.ACTIVE]);
      this.props.onPressIn && this.props.onPressIn(event);
    });

    _defineProperty(this, "onPressOut", event => {
      this.props.eva.dispatch([]);
      this.props.onPressOut && this.props.onPressOut(event);
    });

    _defineProperty(this, "getComponentStyle", source => {
      const {
        iconTintColor,
        iconWidth,
        iconHeight,
        iconMarginHorizontal
      } = source;
      return {
        container: {
          marginHorizontal: iconMarginHorizontal
        },
        icon: {
          width: iconWidth,
          height: iconHeight,
          tintColor: iconTintColor
        }
      };
    });
  }

  render() {
    const _this$props = this.props,
          {
      eva,
      style,
      icon
    } = _this$props,
          touchableProps = _objectWithoutProperties(_this$props, ["eva", "style", "icon"]);

    const evaStyle = this.getComponentStyle(eva.style);
    return /*#__PURE__*/React.createElement(TouchableWeb, _extends({}, touchableProps, {
      style: [evaStyle.container, style],
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onPressIn: this.onPressIn,
      onPressOut: this.onPressOut
    }), /*#__PURE__*/React.createElement(FalsyFC, {
      style: evaStyle.icon,
      component: icon
    }));
  }

}, _temp)) || _class);